import type { TFunction } from 'i18next';

import { EMAIL_RGX, PHONE_RGX } from './constants';

export interface ConfigProps {
	required?: boolean;
	type: 'email' | 'text' | 'string' | 'date' | 'select' | 'iban' | 'phone';
	length?: number[];
	value: string;
	label: string;
	placeholder?: string;
	options?: { key: string; value: string }[];
	order?: number;
	faq?: boolean;
	pricelist?: boolean;
}

export const rulesFor = (cfg: ConfigProps, t: TFunction) => ({
	required: cfg.required ? t('form.required') : false,
	...(cfg.type === 'email'
		? { pattern: { value: EMAIL_RGX, message: t('form.invalidEmail') } }
		: {}),
	...(cfg.type === 'phone'
		? {
				pattern: {
					value: PHONE_RGX,
					message: t('form.invalidPhoneNumber'),
				},
			}
		: {}),
	...(cfg.length?.[0]
		? {
				minLength: {
					value: cfg.length[0]!,
					message: t('form.minLength', { value: cfg.length[0] }),
				},
			}
		: {}),
	...(cfg.length?.[1]
		? {
				maxLength: {
					value: cfg.length[1]!,
					message: t('form.maxLength', { value: cfg.length[1] }),
				},
			}
		: {}),
});
